import * as React from 'react'
import styled from 'styled-components'
import { InjectedIntl, injectIntl } from 'react-intl'
import { RouteComponentProps } from 'react-router-dom'
import Icon from 'antd/lib/icon'
import Layout from '../../components/MainLayout'
import { openLoginAction } from '../../components/MainLayout/actions'
import { connect } from 'react-redux'
import { compose } from 'react-apollo'
import { UserType } from '../../types/common'
import { PrimaryCTA } from '../../theme/components'

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  padding: 52px;
  color: var(--neutral-white);
  background: var(--neutral-darkest);
  #logo {
    max-width: 168px;
  }
  #title {
    font: 300 68px var(--font-barlow);
    margin-block: 18px;
    letter-spacing: 0.025em; 
  }
  #description {
    font: 300 16px var(--font-barlow);
    margin-bottom: 100px;
    font-style: italic;
  }
`

interface Props extends RouteComponentProps<any> {
  intl: InjectedIntl
  user: UserType
  openLoginAction: (open: boolean, callback?: () => void) => void
}

class IdeaGenerator extends React.Component<Props, any> {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
      const { user } = this.props
      if (!user || !user.id) {
        this.handleOpenLogin()
        return
      }
    }
  }

  handleOpenLogin = () => {
    this.props.openLoginAction(true)
  }

  render() {
    const { intl, history, user } = this.props
    const userId = user ? user.id : ''
    const queryParams = userId ? new URLSearchParams({
      firstName: user.name,
      lastName: user.lastName,
      email: user.email,
      userId
    }).toString() : ''
    return (
      <Layout {...{ intl, history }}>
        {!userId ? 
          <LoginContainer>
            <img src="https://storage.googleapis.com/jakroo/homepage/word-logo-white.svg" 
              id="logo" alt="Jakroo" 
            />
            <div id="title">Custom Design Idea Generator</div>
            <div id="description">
              Describe your vision to generate a collection of unique design concepts to spark your creativity.
            </div>
            <Icon type="info-circle" style={{ fontSize: '38px' }} />
            <div style={{ margin: '30px 0', font: '600 18px var(--font-barlow)'}}>
              You must log in before proceeding
            </div>
            <PrimaryCTA maxWidth="200px" data-mode="dark" onClick={this.handleOpenLogin}>Log In</PrimaryCTA> 
          </LoginContainer> : 
          <iframe
            src={`https://custom-design-idea-generator-452333895224.us-west1.run.app?${queryParams}`}
            title="Custom Design Idea Generator"
            frameBorder="0"
            style={{
            width: '100%',
            height: '100vh',
            minHeight: '800px',
            display: 'block',
            border: 'none'
          }}
        />
        }
      </Layout>
    )
  }
}

const mapStateToProps = (state: any) => ({
  user: state.get('app').get('user'),
})

const IdeaGeneratorEnhanced = compose(
  injectIntl,
  connect(mapStateToProps, { openLoginAction })
)

export default IdeaGeneratorEnhanced(IdeaGenerator)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IdeaGenerator/index.tsx